<template>
  <div>
    <!-- 头部 -->
    <top-part></top-part>
    <!-- 头部 -->

    <div
      :class="statusText?'my-online-header text-top':'my-online-header ctn_top'"
      :style="{maxHeight:foldHeight?'calc(100vh - '+ foldHeight +'px)':'',overflowY:foldHeight?'scroll':''}"
      ref="fold"
    >
      <div class="activity_status">{{statusText}}</div>
      <!-- 活动头部 -->
      <div class="my-online-text">
        <div>
          <span :style="{background:btnBackFn(textObj.status)}" v-if='textObj.status' class='statue-btn'>{{textObj.statusName}}</span>
          <div class='my-online-title'>{{textObj.title}}</div>
        </div>
        <div v-for='item in textList' :key='item.label'>
            <span>{{item.label}}</span>
            <!-- 打卡次数 -->
            <div class="content" v-if="item.label=='打卡次数'" style="max-width:78%">
              <div
                v-for="(item2,index) in item.value"
                :key="item2.punchCardId"
                class="sign-location"
              >
                <p>
                  <i class="el-icon-location"></i>
                  <span>打卡点{{index+1}} {{item2.punchCardName}}</span>
                  
                </p>
              </div>
            </div>
            <!-- 打卡次数 -->
            <!-- 活动形式 -->
            <div class="content" v-else-if="item.label=='活动形式'" style="max-width:78%">
              <p class="type" v-if="item.value.length" >
                <p
                  v-for="(item3,index) in item.value"
                  :key="item3.signGroupId"
                >{{item3.signGroupName}} {{index!=item.value.length-1?"、":""}}</p>
              </p>
            </div>
            <!-- 活动形式 -->
            <span v-else :style="{color:item.color?item.color:'#353535'}" style="max-width:78%;display:'inline-block';word-break: break-word">{{item.value}}</span>
        </div>
      </div>
      <!-- 活动头部 -->
      <!-- 活动介绍 -->
      <div class='my-online-intro activity-detail'>
        <div class='my-online-title'>活动介绍</div>
        <div class='activity-content activity-item'>
          <div class="content" style="width:'100%"> 
              <div 
                v-html="textObj.content"
                class="detail"
              ></div>
              
          </div>
        </div>
      </div>
      <!-- 活动介绍 -->
    </div>
    <span
      class="sino-fold-btn"
      @click="toggleFlod"
      v-if="foldBtn"
    >
      {{fold?'收起':"展开"}}
      <span
        :class="['iconfont', fold?'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-6':'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-7']"
      ></span>
    </span>
  </div>
</template>
<script type="text/ecmascript-6">
import topPart from "../../../components/topPart";
import activityConfig from '../../../centralControl/utils/activityConfig'
export default {
  props:["textList","textObj","statusText","type"],
  components: {
    topPart
  },
  data() {
    return {
      foldHeight:this.type==3?'260':'350',
      foldBtn: true,
      fold:false,
      title:''
    };
  },
  watch:{
    // 处理展开与收起的逻辑
    title(val){ 
          this.$nextTick(()=>{
            let actualheight = this.$refs.fold.offsetHeight;
            let scrollHeight = this.$refs.fold.scrollHeight;
            console.log(actualheight,scrollHeight)
            this.contentScollHeight = scrollHeight;
            if (scrollHeight <= actualheight) {
              this.foldBtn = false;
            }
        })
    }
    },
  mounted(){
    this.title=this.textObj.title;
  },
  methods:{
    //按钮颜色
    btnBackFn(statue){
      let colorObj=activityConfig.colorObj
      return colorObj[statue];
    },
    // 展开收起
    toggleFlod() {
      this.foldHeight="";
      this.fold = !this.fold;
      if (!this.fold) {
        this.foldHeight=this.type==3?'260':'350'
      }
    },
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../../assets/stylus/common.styl';
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/detail.styl';
.text-top {
  margin-top: 69px;
  
}
.my-online-header{
  background: #FFF;
  .activity_status {
    width: 100%;
    line-height: 26px;
    background: #FF4B4B;  
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    position: fixed;
    top: 44px;
    left: 0;
    z-index: 99;
  }
  .my-online-text {
    padding: 15px;
    border-bottom: 1px solid $border-gray;
    >div {
      display: flex;
      align-items:center;
    }
    >div:not(:first-child){
      margin-top: 10px;
      span {
        font-size:14px;
        font-weight:500;
        font-family:PingFang SC;
      }
      span:nth-child(1){
        color:$text-gray2;
        margin-right:14px;
      }
    }
    .statue-btn {
      activityStatueBtn();
    }
   
  }
  .my-online-title {
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:$text-black;
  }
  .my-online-title:nth-child(2){
    text-indent:4px;
  }
  .my-online-intro {
    padding: 15px;
  }
 
}
</style>